module.exports = __webpack_public_path__ + "img/rouge.1a903396.png";